// extracted by mini-css-extract-plugin
module.exports = {"listMargin":"IconExplainer_listMargin__1lElU","listItemMargin":"IconExplainer_listItemMargin__2v_3e","iconMargin":"IconExplainer_iconMargin__3fH-A"};